import { render, staticRenderFns } from "./etapa_12.vue?vue&type=template&id=1d25640c&scoped=true&"
import script from "./etapa_12.vue?vue&type=script&lang=js&"
export * from "./etapa_12.vue?vue&type=script&lang=js&"
import style0 from "./etapa_12.vue?vue&type=style&index=0&id=1d25640c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d25640c",
  null
  
)

export default component.exports